import React from 'react';
import { IoLocationSharp, IoCallSharp, IoMailSharp } from "react-icons/io5";
import { FaFacebook } from "react-icons/fa";
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import "./ContactComponent.css";

const ContactRowComponent = ({ title, links }) => {
    const titleStyle = {
        color: '#1B1B1D',
        fontFamily: "'FiraGO-SemiBold'",
        fontSize: '18px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '140%',
        marginBottom: '8px',
        opacity: '0.5'
    };

    const linkStyle = {
        color: '#1B1B1D',
        fontFamily: "'FiraGO-Medium'",
        fontSize: '18px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '200%',
        textDecoration: 'none'
    };


    const renderIcon = (icon) => {
        const iconStyle = {
            backgroundColor: '#f5f5f5',
            borderRadius: '50%',
            padding: '10px',
            display: 'inline-flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginRight: '10px',
        };

        const transparentIconStyle = {
            backgroundColor: '#E0E0E0',
            borderRadius: '50%',
            padding: '10px',
            display: 'inline-flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginRight: '10px',
        };

        switch (icon) {
            case 'location':
                return <div style={iconStyle}><IoLocationSharp color="#d32f2f"  size={25}/></div>;
            case 'mail':
                return <div style={iconStyle}><IoMailSharp color="#1565c0" size={25}/></div>;
            case 'transparent':
                return <div style={transparentIconStyle}><IoMailSharp color="#E0E0E0" size={25}/></div>;
            case 'phone':
                return <div style={iconStyle}><IoCallSharp color="#2e7d32" size={25}/></div>;
            case 'facebook':
                return <div style={iconStyle}><FaFacebook color="#3b5998" size={25}/></div>;
            default:
                return null;
        }
    };


    const renderLink = (link) => {
        const isExternal = link.to && (link.to.startsWith('http') || link.to.startsWith('https'));

        if (link.icon === 'phone') {
            const formattedNumber = link.text.replace(/\s+/g, '');
            return (
                <a href={`tel:${formattedNumber}`} style={linkStyle}>
                    {link.text}
                </a>
            );
        } else if (link.icon === 'mail') {
            return (
                <a href={`mailto:${link.text}`} style={linkStyle}>
                    {link.text}
                </a>
            );
        } else if (isExternal) {
            return (
                <a href={link.to} style={linkStyle} target="_blank" rel="noopener noreferrer">
                    {link.text}
                </a>
            );
        } else {
            return (
                <Link to={link.to || '#'} style={linkStyle}>
                    {link.text}
                </Link>
            );
        }
    };

    return (
        <div className={"contact-component-container"}>
            <div style={titleStyle}>{title}</div>
            {links.map((link, index) => (
                <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: 10 }}>
                    {renderIcon(link.icon)}
                    {renderLink(link)}
                </div>
            ))}
        </div>
    );
};

const ContactComponent = () => {
    const { t } = useTranslation();

    const contactData = {
        links: [
            {
                to: 'https://www.google.com/maps/place/LEPL+Technical+and+Construction+Supervision+Agency/@41.7200275,44.713523,15z/data=!4m2!3m1!1s0x0:0x736507bdf1364e8f?sa=X&ved=2ahUKEwiO5MPtnvWCAxWwZ_EDHWGMCVQQ_BJ6BAgJEAA',
                text: t('address'),
                icon: 'location'
            },
            {text: "032 2 34 77 13", icon: 'phone'},
            {text: t('tacsa@moesd.gov.ge'), icon: 'mail'},
            {to: 'https://www.facebook.com/tacsa.gov.ge', text: t('facebook'), icon: 'facebook'},
        ],
    };

    return (
        <div className={"contact-row-container"}>
            <ContactRowComponent title={contactData.title} links={contactData.links} />
        </div>
    );
};

export default ContactComponent;
